import {useCallback, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";

// И2 — въпрос към администратора от раздел „Помощ" + „Моите въпроси".
// Отговорът се получава ТУК, в приложението (на сървъра няма поща).

const MAX_LEN = 1000;
const MIN_LEN = 5;

const STATUS_LABELS = {
    new: {text: "нов", cls: "bg-secondary"},
    in_progress: {text: "в работа", cls: "bg-warning text-dark"},
    answered: {text: "отговорен", cls: "bg-success"},
};

const StatusBadge = ({status}) => {
    const s = STATUS_LABELS[status] || STATUS_LABELS.new;
    return <span className={`badge ${s.cls}`}>{s.text}</span>;
};

export const AskQuestion = () => {
    const location = useLocation();
    const request = requester();

    const [text, setText] = useState("");
    const [sending, setSending] = useState(false);
    const [error, setError] = useState("");
    const [sent, setSent] = useState(false);
    const [questions, setQuestions] = useState([]);

    const load = useCallback(() => {
        request.get(`${baseUrl()}/questions/mine`)
            .then(setQuestions)
            .catch(() => setQuestions([]));   // празен списък не е повод за грешка на екрана
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    const trimmed = text.trim();
    const canSend = trimmed.length >= MIN_LEN && !sending;

    const onSubmit = (e) => {
        e.preventDefault();
        if (!canSend) return;

        setSending(true);
        setError("");
        setSent(false);

        request.post(`${baseUrl()}/questions`, {
            text: trimmed,
            // Откъде е зададен въпросът — за да знае админът контекста.
            context_url: location.pathname,
        })
            .then(() => {
                setText("");
                setSent(true);
                load();
            })
            .catch(err => setError(err.message || "Въпросът не можа да бъде изпратен."))
            .finally(() => setSending(false));
    };

    return (
        <>
            <p>
                Ако не намирате отговор в това ръководство, задайте въпрос. Ще получите отговор
                на това място — проверявайте периодично.
            </p>

            <form onSubmit={onSubmit} className="mb-4">
                <textarea className="form-control" rows={4} maxLength={MAX_LEN}
                          placeholder="Например: Как да махна землище, което съм добавил по грешка?"
                          value={text} onChange={e => setText(e.target.value)}/>
                <div className="d-flex justify-content-between align-items-center mt-2 flex-wrap gap-2">
                    <small className="text-muted">
                        {trimmed.length < MIN_LEN
                            ? `Още поне ${MIN_LEN - trimmed.length} знака`
                            : `Остават ${MAX_LEN - text.length} знака`}
                    </small>
                    <button type="submit" className="btn btn-outline-secondary" disabled={!canSend}>
                        {sending ? "Изпращане…" : "Изпрати"}
                    </button>
                </div>
            </form>

            {sent && <div className="alert alert-success">Въпросът е изпратен.</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            {questions.length > 0 && (
                <>
                    <h5 className="mt-4">Моите въпроси</h5>
                    {questions.map(q => (
                        <div key={q.id} className="card mb-2">
                            <div className="card-body py-2">
                                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                    <small className="text-muted">{q.create_on}</small>
                                    <StatusBadge status={q.status}/>
                                </div>
                                <div className="mt-1" style={{whiteSpace: "pre-wrap"}}>{q.text}</div>

                                {q.answer && (
                                    <div className="mt-2 p-2 rounded"
                                         style={{background: "var(--app-surface-2)"}}>
                                        <div className="fw-bold">Отговор:</div>
                                        <div style={{whiteSpace: "pre-wrap"}}>{q.answer}</div>
                                        <small className="text-muted">
                                            {q.answered_by} · {q.answered_on}
                                        </small>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </>
            )}
        </>
    );
};
